import { useEffect, useState } from "react";
import { isPWA } from "../utils";

const useProgressiveWebApp = () => {   
    const [isAppInstalled, setIsAppInstalled] = useState(isPWA())
    const [isUserSwitchedBetweenApps, setIsUserSwitchedBetweenApps] = useState(false) 
    useEffect(()=> {

        window.addEventListener('focus',()=> {
            const curentPWAStatus = isPWA()
            if (curentPWAStatus !== isAppInstalled) {
                setIsAppInstalled(curentPWAStatus)
                setIsUserSwitchedBetweenApps(true)
            }
            else {
                setIsUserSwitchedBetweenApps(false)
            }
        })

        return ()=> {
            window.removeEventListener('focus',()=> {
                const curentPWAStatus = isPWA()
                if (curentPWAStatus !== isAppInstalled) {
                    setIsAppInstalled(curentPWAStatus)
                    setIsUserSwitchedBetweenApps(true)
                }
                else {
                    setIsUserSwitchedBetweenApps(false)
                }
            })
        }

    },[])

    
    return { isAppInstalled, isUserSwitchedBetweenApps }
}

export default useProgressiveWebApp;